module.exports = __webpack_public_path__ + "img/lounge_hover_e5a97dc.webp";